// Конфигурация сервера (/api/config): загружается один раз при старте
import type { SiteConfig } from '@sayohat/shared';
import { api } from './api';
import { bus } from './bus';
import { createStore, useStore } from './store';

const DEFAULT: SiteConfig = {
  demo: false,
  telegram: null,
  pushKey: null,
  ai: false,
  agency: { name: 'Sayohat', phone: '', telegram: '', whatsapp: '', email: '' },
  banner: null,
  pickMarkup: 0,
  liveSearch: false,
  whiteLabel: null,
};

const configStore = createStore<SiteConfig & { loaded: boolean }>({ ...DEFAULT, loaded: false });

/** Текущая конфигурация (для кода вне компонентов) */
export const getConfig = (): SiteConfig => configStore.get();

export function useConfig(): SiteConfig & { loaded: boolean } {
  return useStore(configStore);
}

let loading: Promise<SiteConfig> | null = null;

export function loadConfig(): Promise<SiteConfig> {
  if (!loading) {
    loading = api<Partial<SiteConfig>>('/api/config').catch((): Partial<SiteConfig> => ({})).then((data) => {
      const cfg: SiteConfig = { ...DEFAULT, ...data, agency: { ...DEFAULT.agency, ...(data.agency || {}) } };
      configStore.replace({ ...cfg, loaded: true });
      bus.emit('config', cfg);
      return cfg;
    });
  }
  return loading;
}
